module.exports = require('buffer')



//////////////////
// WEBPACK FOOTER
// ./~/readable-stream/~/string_decoder/~/safe-buffer/browser.js
// module id = 222
// module chunks = 0